<template>
    <div class="routelist">

        <ul class="routes">

            <li v-for="route in routen">
                <router-link :to="{ name: 'route', params: { routeId: route.id }}">

                    <template v-if="language=='de'">
                        {{ route.de.Titel }}
                    </template>
                    <template v-if="language=='pl'">
                        {{ route.pl.Titel }}
                    </template>

                    <font-awesome-icon icon="chevron-right" class="pfeil" size="lg"/>

                </router-link>
            </li>
        </ul>
    </div>
</template>

<script type="text/babel">
    export default {
        name: 'RouteListe',
        props: {
            routen: Array
        },
        computed: {
            language: function () {
                return this.$root.$i18n.locale;
            }
        }
    }
</script>

<style scoped lang="scss">

</style>
